export const THERMOSTAT_MAX_LOAD_WATTS = 3600;

export const getTotalMatOutput = (matData) =>
  Object.values(matData?.matParams || {}).reduce(
    (total, mat) => total + (Number(mat.Wattage) || 0),
    0
  );

export const requiresContactor = (matData) =>
  getTotalMatOutput(matData) > THERMOSTAT_MAX_LOAD_WATTS;
